import {
  Button,
  Grid,
  Heading,
  IconConfigureLine,
  IconInfoSolid,
  Tooltip,
} from "@instructure/ui";
import { t } from "i18next";
import React, { useContext, useState } from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { UserDetailContext } from "../../../utils/Context";
import { isBetaOrDev } from "../../../utils/URIUtils";
import ConfigureMasteryLevelsModal from "./ConfigureMasteryLevelsModal";

const MasteryLevels = ({ masteryLevels, loading, setUpdateMasteryLevels }) => {
  const userDetails = useContext(UserDetailContext);
  const [openConfigureModal, setOpenConfigureModal] = useState(false);
  const betaOrDev = isBetaOrDev(window.location.href);

  return (
    <Grid startAt="large">
      <Grid.Row vAlign="middle">
        <Grid.Col>
          <Heading level="h3">
            {t("masteryLevels.masteryLevelsHeader")}{" "}
            <Tooltip
              renderTip={
                <div style={{ width: 800 }}>
                  {t("masteryLevels.masteryLevelsInfo")}
                </div>
              }
              on={["hover", "focus"]}
              placement="top end"
              style
            >
              <IconInfoSolid size="x-small" color="brand" />
            </Tooltip>
          </Heading>
        </Grid.Col>
        {betaOrDev && userDetails.isAC() && (
          <Grid.Col width="auto">
            <Button
              id="configure-mastery-levels-button"
              color="primary"
              onClick={() => setOpenConfigureModal(true)}
              renderIcon={IconConfigureLine}
            >
              {t("masteryLevels.configMasteryLevels")}
            </Button>
            <ConfigureMasteryLevelsModal
              open={openConfigureModal}
              setOpen={setOpenConfigureModal}
              handleClose={() => setOpenConfigureModal(false)}
              masteryLevels={masteryLevels}
              setUpdate={setUpdateMasteryLevels}
            />
          </Grid.Col>
        )}
      </Grid.Row>
      <Grid.Row>
        {loading
          ? [...Array(5)].map((_, index) => (
              <Grid.Col key={index}>
                <Skeleton height={200} />
              </Grid.Col>
            ))
          : masteryLevels.map((level, key) => (
              <Grid.Col key={key}>
                <div
                  style={{
                    border: "1px solid #ccc",
                    borderRadius: "5px",
                    padding: "10px 15px",
                    minHeight: "120px",
                  }}
                >
                  <Heading as="h3" level="h4" margin="0 0 small 0">
                    {level.level}
                  </Heading>
                  <p>{level.description}</p>
                </div>
              </Grid.Col>
            ))}
      </Grid.Row>
    </Grid>
  );
};

export default MasteryLevels;
